import { useNavigate } from "react-router"
import { useDispatch, useSelector } from "react-redux"

import "./index.scss"
import Button from "react-bootstrap/Button"

import { auth } from "state_management"
import useT from "utils/hooks/useT"

export default function ManageScreen() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const memberId = useSelector((state) => state.auth.memberId)
  const currentMemberShowOnPlan = useSelector((state) => state.auth.memberId && state.members[state.auth.memberId] ? state.members[state.auth.memberId].showOnPlan : true)
  const isViewOnly = useSelector((state) => state.auth.isViewOnly)
  const { t: tc } = useT("common")

  return (
    <div className="ManageScreen-main-container">
      <div className="ManageScreen-item ManageScreen-Logo">
        <p>{tc("plannertech")}</p>
      </div>
      <div className="ManageScreen-item ManageScreen-TeamPlanButton">
        <Button title={tc("teamPlan")} onClick={() => navigate(`/`)}>
          {tc("teamPlan")}
        </Button>
      </div>
      {currentMemberShowOnPlan && (
      <div className="ManageScreen-item ManageScreen-MemberPlanButton">
        <Button title={tc("memberPlan")} onClick={() => navigate(`/member/${memberId}`)}>
          {tc("memberPlan")}
        </Button>
      </div>
      )}
      {!isViewOnly && (
      <div className="ManageScreen-item ManageScreen-MemberPlanButton">
        <Button title={tc("qcLibrarian")} onClick={() => navigate(`/librarian`)}>
          {tc("qcLibrarian")}
        </Button>
      </div>
      )}
      <div className="ManageScreen-item Managescreen-Logout">
        <Button
          title={tc("logout")}
          variant="secondary"
          onClick={() => dispatch(auth.logout()).then(() => navigate("/login"))}
        >
          {tc("logout")}
        </Button>
      </div>
    </div>
  )
}
